export default __webpack_public_path__ + "static/media/Bangles.648bf387.jpg";